<template><div><h1 id="berufe-branchen" tabindex="-1"><a class="header-anchor" href="#berufe-branchen"><span>Berufe, Branchen</span></a></h1>
<p>Berufe, Branchen — Definiert Berufe / Branschen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient der Definition der Berufe / Branchen, welche zur Adresse erfasst werden können. Nur Werte aus dieser Tabelle können eingegeben werden, wobei pro Adresse nur 1 Wert möglich ist.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Merkmale Personen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Code</dt>
<dd>Kürzel für Berufs-/Branchenbezeichnung, 4-stellig, alphanumerisch</dd>
<dt>Berufs-/Branchenbezeichnung</dt>
<dd>Berufs-/Branchenbezeichnung</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/adressbereinigung.html" title="Kapitel 2. Kundenpflege und Akquisition">Kundenpflege</RouteLink></p>
</div></template>


